import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { Box } from "@mui/material";
import { useSelector } from "@xstate/react";
import { AnimatePresence, motion } from "framer-motion";
import _startCase from "lodash/startCase";

import CardBrandIcon from "../../../../pages/AppPages/Dashboard/Wallet/CardBrandIcon";
import { StoreAnimatedHeightDiv } from "../../../../StoreComponents/StoreAnimatedHeightDiv";
import { useFastCheckoutContext } from "../../../CheckoutMachine";

import Stripe from "stripe";
import { UserRetailerCheckoutOrder } from "../../../types";
import { PaymentMethodDisplay } from "../../CheckoutV2/CheckoutForm/components/PaymentMethodDisplay";
import InfoBox from "../InfoBox";
import { StoreErrorV2 } from "@/components/StoreComponents/StoreError";

const PaymentMethod = ({
  paymentMethod,
  stripePaymentMethod,
}: {
  paymentMethod: UserRetailerCheckoutOrder["paymentMethod"];
  stripePaymentMethod: Stripe.PaymentMethod | undefined;
  onAddPaymentMethod: () => void;
}) => {
  if (!paymentMethod) {
    if (stripePaymentMethod) {
      return <PaymentMethodDisplay paymentMethod={stripePaymentMethod} />;
    }
    return (
      <InfoBox message="Please add a payment method to your retailer account." />
    );
  }

  return (
    <div className="info_box">
      <div className="info_row">
        <CardBrandIcon
          className="icon"
          alt="icon"
          cardBrand={paymentMethod?.cardIssuer?.toLocaleLowerCase()}
        />
        {_startCase(paymentMethod?.cardIssuer || "")} ending in{" "}
        {paymentMethod?.cardNumberEnding}
      </div>
    </div>
  );
};
const PaymentSection = () => {
  const { actorRef, send } = useFastCheckoutContext();

  const open = useSelector(
    actorRef,
    (state) => state.context.sectionState.payment.open
  );

  const errorMessage = useSelector(
    actorRef,
    (state) => state.context.sectionState.payment.errorMessage
  );

  // const chevronShow = useSelector(
  //   actorRef,
  //   (state) => state.context.sectionState.payment.chevronShow
  // );

  // const toggleOpen = () => {
  //   if (open) {
  //     send({
  //       type: "ON_SESSION_CLOSE",
  //       data: { sessionToClose: "payment" },
  //     });
  //   } else {
  //     send({
  //       type: "ON_SESSION_OPEN",
  //       data: { sessionToOpen: "payment" },
  //     });
  //   }
  // };

  const userRetailerCheckoutOrder = useSelector(
    actorRef,
    (snapshot) =>
      snapshot.context.retailerCheckoutOrderStatus?.userRetailerCheckoutOrder
  );

  return (
    <Box className="section">
      <div className="section_head" style={{ cursor: "pointer" }}>
        <div className="title">{"Payment Method"}</div>
        {/* {chevronShow ? (
          <ChevronDownIcon
            style={{
              transition: "transform 0.3s",
              width: "33px",
              height: "33px",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
            onClick={toggleOpen}
          ></ChevronDownIcon>
        ) : null} */}
      </div>
      <StoreAnimatedHeightDiv>
        <StoreErrorV2
          errorMessage={errorMessage}
          sx={{
            width: "fit-content",
            marginTop: "2.2px",
            marginBottom: "24px",
            [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
              marginTop: "0px",
              marginBottom: "15px",
            },
          }}
        />
        <PaymentMethod
          paymentMethod={userRetailerCheckoutOrder?.paymentMethod}
          stripePaymentMethod={
            userRetailerCheckoutOrder?.userCheckoutInfo?.stripePaymentMethod
          }
          onAddPaymentMethod={() => {
            send({
              type: "ON_SESSION_OPEN",
              data: { sessionToOpen: "payment" },
            });
          }}
        />
        <AnimatePresence mode="wait">
          <motion.div
            layout="position"
            key={open ? "view" : "edit"}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
          ></motion.div>
        </AnimatePresence>
      </StoreAnimatedHeightDiv>
    </Box>
  );
};

export default PaymentSection;
